/**
 * Constants for AssignedQueries page component
 */

// Reuse REGION_OPTIONS and STATUS_CARD_CONFIG from raiseQueryPage
export { REGION_OPTIONS, STATUS_CARD_CONFIG } from './raiseQueryPage';

export const DEFAULT_QUERY_TYPE_OPTIONS = [
  { value: 'General', label: 'General' },
  { value: 'Technical', label: 'Technical' },
  { value: 'Financial', label: 'Financial' },
  { value: 'Operational', label: 'Operational' },
  { value: 'Other', label: 'Other' },
];

export const LIFECYCLE_STATUS_STYLES = {
  submitted: { label: 'Submitted', color: '#1d4ed8' },
  open: { label: 'Open', color: '#4f9da6' },
  pending: { label: 'Pending', color: '#f39c3d' },
  responded: { label: 'Responded', color: '#1e40af' },
  resolved: { label: 'Resolved', color: '#2e7d32' },
  escalated: { label: 'Escalated', color: '#d97706' },
  delegated: { label: 'Delegated', color: '#0ea5e9' },
  reopened: { label: 'Need Clarification', color: '#7c3aed' },
  additional_clarification: { label: 'Additional Clarification', color: '#f59e0b' },
  closed: { label: 'Closed', color: '#388e3c' },
};

export const ASSIGN_DIALOG_DEFAULTS = {
  reason: 'Handing off to responder',
  note: 'Awaiting response',
};
